import { createAction } from '@reduxjs/toolkit'
// 交易对信息接口
export interface TradingPair {
  token0: {
    chainId: number
    address: string
    decimals: number
    symbol: string
    name: string,
    logo?: string,
    key?: string,
  }
  token1: {
    chainId: number
    address: string
    decimals: number
    symbol: string
    name: string,
    logo?: string,
    key?: string,
  }
  pairAddress?: string
  reserve0?: string
  reserve1?: string
  price?: string
  priceChange24h?: string
  volume24h?: string
}

// 打开K线图弹窗
export const openKlineModal = createAction<void>('kline/openKlineModal')

// 关闭K线图弹窗
export const closeKlineModal = createAction<void>('kline/closeKlineModal')

// 更新当前选中的交易对信息
export const updateTradingPair = createAction<TradingPair>('kline/updateTradingPair')

// 设置当前交易对信息
export const setCurrentTradingPair = createAction<TradingPair>('kline/setCurrentTradingPair')

// 清除交易对信息
export const clearTradingPair = createAction<void>('kline/clearTradingPair')